<template>
  <div class="spin_parent">
    <Table
      size="small"
      :loading="spin"
      :disabled-hover="true"
      :columns="columns"
      :data="data"
    ></Table>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  props: {
    row: Object,
  },
  data() {
    return {
      spin: false,
      data: [],
      columns: [
        { title: "编号", key: "id" },
        { title: "序列号", key: "sn" },
        { title: "代理商", key: "agent_name" },
        { title: "站点", key: "site_name" },
        {
          title: "地址",
          key: "address",
          render: (h, data) => {
            return h(
              "span",
              {},
              `${data.row.province || ""}-${data.row.city || ""}-${
                data.row.area || ""
              }`
            );
          },
        },
        {
          title: "状态",
          key: "machine_status",
          render: (h, data) => {
            return h(
              "span",
              {
                style: {
                  color: data.row.machine_status ? "#19be6b" : "#ed4014",
                },
              },
              data.row.machine_status ? "连接" : "断开"
            );
          },
        },
        {
          title: "操作",
          width: 135,
          key: "operate",
          render: (h, data) => {
            return h("div", {}, [
              h(
                "Button",
                {
                  props: { type: "warning", size: "small", ghost: true },
                  on: {
                    click: () => {
                      this.$Modal.confirm({
                        title: "解绑屏保",
                        content: `是否将该屏保从该设备上解除?`,
                        onOk: () => {
                          this.saveMachine({
                            id: data.row.id,
                            machine_ad_id: null,
                          }).then((res) => {
                            this.getData();
                            if (data.row.machine_status) {
                              this.socketSend({
                                action: 10007,
                                value: { sn: data.row.sn, data: "" },
                              });
                            }
                          });
                        },
                      });
                    },
                  },
                },
                "解绑"
              ),
              h(
                "Button",
                {
                  style: { marginLeft: "5px" },
                  props: {
                    type: "info",
                    size: "small",
                    ghost: true,
                    disabled: data.row.machine_status ? false : true,
                  },
                  on: {
                    click: () => {
                      this.socketSend({
                        action: 10007,
                        value: { sn: data.row.sn, data: this.row.src },
                      });
                      this.success("发布成功");
                    },
                  },
                },
                "发布"
              ),
            ]);
          },
        },
      ],
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      this.spin = true;
      this.GetMachinesByScreenSaver({ id: this.row.id }).then((res) => {
        this.data = res;
        this.spin = false;
        let sns = [];
        res.map((item) => {
          sns.push(item.sn);
          this.socketSend({ action: 10009, value: { sn: item.sn } });
        });
        /*  this.socketSend({ action: 10002, value: { sns: sns } }).then(result=>{
            console.log(58,this.machine)
          }); */
      });
    },
    ...mapActions(["GetMachinesByScreenSaver", "socketSend", "saveMachine"]),
  },
  computed: mapGetters({
    socket: "socket",
    machine: "machine",
    machine_info: "machine_info",
  }),
};
</script>

<style lang="less" scoped>
.spin_parent {
  position: relative;
}
.spin {
  position: absolute;
  display: inline-block;
  width: 100%;
  height: 100%;
}
</style>
